import { render, staticRenderFns } from "./CrossSellsCarousel.vue?vue&type=template&id=7c6188e5&scoped=true&"
import script from "./CrossSellsCarousel.vue?vue&type=script&lang=js&"
export * from "./CrossSellsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./CrossSellsCarousel.vue?vue&type=style&index=0&id=7c6188e5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6188e5",
  null
  
)

export default component.exports